import { createContext, useContext, useMemo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "./useLocalStorage";
import moment from 'moment';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useLocalStorage("userData", null);
  const navigate = useNavigate();

  const login = useCallback(async (data) => {
    setUser(data);
    navigate("/landing", { replace: true });
  }, [navigate, setUser]);

  const isTokenExpired = useCallback((token) => {
    let isExpired = false;
    
    if (token.exp_it)
    {
      isExpired = moment().isSameOrAfter(moment(token.exp_it))
    }
    return isExpired;
  },[]);

  const logout = useCallback((auto) => {
    setUser(null);

    // if (auto)
    //   navigate("/logout", { replace: true });
  }, [setUser]);

  const value = useMemo(
    () => ({
      user,
      login,
      logout,
      isTokenExpired
    }),
    [user, login, logout, isTokenExpired]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};
